export default {
  issue: {
    created_at: '',
    url: '',
    iid: '',
    title: '',
    total_time: {},
    author: {
      avatar_url: '',
      id: '',
      name: '',
      web_url: '',
    },
  },
  plan: {
    title: '',
    commit_url: '',
    short_sha: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: '',
    },
  },
  code: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: '',
    },
  },
  test: {
    name: '',
    id: '',
    date: '',
    url: '',
    short_sha: '',
    commit_url: '',
    total_time: {},
    branch: {
      name: '',
      url: '',
    },
  },
  review: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    state: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: '',
    },
  },
  staging: {
    id: '',
    short_sha: '',
    date: '',
    url: '',
    commit_url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: '',
    },
    branch: {
      name: '',
      url: '',
    },
  },
  production: {
    title: '',
    created_at: '',
    url: '',
    iid: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: '',
    },
  },
};
